







import Vue from 'vue'
import Navbar from '@/components/navbar/Navbar.vue'

export default Vue.extend({
  components: {
    Navbar
  }
})
